import React from 'react';
import styles from './MobileHeader.scss';
import { classes } from './Widget.st.css';
import cx from 'classnames';

export default ({
  onCancel,
  onPublish,
}: {
  onCancel: () => void;
  onPublish: () => void;
}) => (
  <div className={cx(styles.header, classes.backgroundColor)}>
    <div className={styles.button} onClick={onCancel}>
      Cancel
    </div>
    <div className={styles.button} onClick={onPublish}>
      Publish
    </div>
  </div>
);
